<div>
  <h2 class="page-header left">Listados Remitos Emitidios</h2>

  <form class="form-container" appearance="outline" [formGroup]="reportRemitoForm" #formDirective="ngForm" autocomplete="off">



    <div class="row row-spacing">
      <div style="text-align:right;">
        <button mat-icon-button class="view-remito-buttons" (click)="searchAndPrint(true)" [disabled]="isLoading">
          <mat-icon *ngIf="!isLoading">print</mat-icon>
          <mat-spinner *ngIf="isLoading" class="loading-spinner-small" diameter="15"></mat-spinner>
        </button>
        <button mat-icon-button class="view-remito-buttons" (click)="searchAndPrint(false)"><mat-icon>pageview</mat-icon></button>
      </div>
    </div>

    <mat-divider class="mat-divider-header"></mat-divider>
    <div class="data-container">
      <div class="row row-spacing">

        <div class="col-xl-3 col-lg-3 col-md-6 col-sm-12 col-xs-12">
          <mat-form-field class="col-lg-12 col-md-12 col-sm-12" appearance="outline">
            <mat-label>Tipo de remito</mat-label>
            <mat-select placeholder="Origen" (selectionChange)="onChangeOrigen($event)">
              <mat-option value="-1"></mat-option>
              <mat-option *ngFor="let org of origen" [value]="org" [formControl]="origenControl" ngDefaultControl >
                {{ org }}
              </mat-option>
            </mat-select>
          </mat-form-field>
        </div>

        <div class="col-xl-3 col-lg-3 col-md-6 col-sm-12 col-xs-12">
          <mat-form-field class="col-lg-12 col-md-12 col-sm-12" appearance="outline">
            <mat-label>Número de Remito inicial</mat-label>
            <input matInput placeholder="NRO Remito" [formControl]="nroRemitoStartValControl">
          </mat-form-field>
        </div>

        <div class="col-xl-3 col-lg-3 col-md-6 col-sm-12 col-xs-12">
          <mat-form-field class="col-lg-12 col-md-12 col-sm-12" appearance="outline">
            <mat-label>Número de Remito final </mat-label>
            <input matInput placeholder="NRO Remito" [formControl]="nroRemitoEndValControl">
          </mat-form-field>
        </div>
      </div>

      <div class="row row-spacing">

        <div class="col-xl-3 col-lg-3 col-md-6 col-sm-12 col-xs-12">
          <mat-form-field class="col-lg-12 col-md-12 col-sm-12" appearance="outline">
            <mat-label>Pto emisión</mat-label>
            <mat-select placeholder="Pto Emision"  (selectionChange)="onChangePtoEmision($event)"  panelClass="mat-select-dropdown">
              <mat-option value="-1"></mat-option>
              <mat-option *ngFor="let ptoEmision of allPtoEmision" [value]="ptoEmision.code" [formControl]="ptoEmisionControl" ngDefaultControl >
                {{ ptoEmision.code }}
              </mat-option>
            </mat-select>
          </mat-form-field>
        </div>


        <div class="col-xl-3 col-lg-3 col-md-6 col-sm-12 col-xs-12">
          <mat-form-field class="col-lg-12 col-md-12 col-sm-12" appearance="outline">
            <mat-label>Destinatario</mat-label>
            <input type="text" matInput [formControl]="destinatarioControl"  [matAutocomplete]="autoDestinatario">
            <mat-autocomplete #autoDestinatario="matAutocomplete">
              <mat-option *ngFor="let destinatario of filteredDestinatario | async"
                          [value]="destinatario.id + ' - ' + destinatario.desc">
                {{destinatario.id}} - {{destinatario.desc}}
              </mat-option>
            </mat-autocomplete>
          </mat-form-field>

        </div>


        <div class="col-xl-3 col-lg-3 col-md-6 col-sm-12 col-xs-12">
          <mat-form-field class="col-lg-12 col-md-12 col-sm-12" appearance="outline">
            <mat-label>Almacen</mat-label>
            <input type="text" matInput [formControl]="almacenControl" [matAutocomplete]="autoAlmacen">
            <mat-autocomplete #autoAlmacen="matAutocomplete">
              <mat-option *ngFor="let almacen of filteredAlmacen | async"
                          [value]="almacen.codAlmacen + ' - ' + almacen.descAlmacen">
                {{ almacen.codAlmacen }} - {{ almacen.descAlmacen }}
              </mat-option>
            </mat-autocomplete>
          </mat-form-field>
        </div>


      </div>

      <div class="row row-spacing">

        <div class="col-xl-3 col-lg-3 col-md-6 col-sm-12 col-xs-12">
          <mat-form-field class="col-lg-12 col-md-12 col-sm-12" appearance="outline">
            <mat-label>Nro Shipper</mat-label>
            <input matInput placeholder="Shipper value" [formControl]="nroShipperControl">
          </mat-form-field>
        </div>


        <div class="col-xl-3 col-lg-6 col-md-12 col-sm-12 col-xs-12">
          <mat-form-field class="col-lg-12 col-md-12 col-sm-12" appearance="outline">
            <mat-label>Fecha Desde</mat-label>
            <input matInput [matDatepicker]="fechaDesde" [formControl]="fechaDesdeControl">
            <mat-hint>DD/MM/YYYY</mat-hint>
            <mat-datepicker-toggle matSuffix [for]="fechaDesde"></mat-datepicker-toggle>
            <mat-datepicker #fechaDesde></mat-datepicker>
          </mat-form-field>
        </div>

        <div class="col-xl-3 col-lg-6 col-md-12 col-sm-12 col-xs-12">
          <mat-form-field class="col-lg-12 col-md-12 col-sm-12" appearance="outline">
            <mat-label>Fecha Hasta</mat-label>
            <input matInput [matDatepicker]="fechaHasta" [formControl]="fechaHastaControl">
            <mat-hint>DD/MM/YYYY</mat-hint>
            <mat-datepicker-toggle matSuffix [for]="fechaHasta"></mat-datepicker-toggle>
            <mat-datepicker #fechaHasta></mat-datepicker>
          </mat-form-field>
        </div>

      </div>
    </div>
  </form>


  <!-- Report table -->
  <div class="table-height table-flex" *ngIf="showReportData">
    <table mat-table matSort [dataSource]="dataSource">

      <!-- Origen -->
      <ng-container matColumnDef="origen">
        <th mat-header-cell *matHeaderCellDef mat-sort-header> Origen
          <rem-string-filter #tableFilter columnDef="origen" [operators]="operators" (filterChange)="filterChange($event);"></rem-string-filter>
        </th>
        <td mat-cell class="center-padding" *matCellDef="let element">
           <span>
                {{element.origen}}
           </span>
        </td>
      </ng-container>

      <!-- Nro Remito -->
      <ng-container matColumnDef="nroRemito">
        <th mat-header-cell *matHeaderCellDef mat-sort-header> Nro Remito
          <rem-string-filter #tableFilter columnDef="nroRemito" [operators]="operators" (filterChange)="filterChange($event);"></rem-string-filter>
        </th>
        <td mat-cell class="center-padding" *matCellDef="let element">
           <span>
                {{element.nroRemito}}
           </span>
        </td>
      </ng-container>

      <!-- Dealer -->
      <ng-container matColumnDef="nombreDealer">
        <th mat-header-cell *matHeaderCellDef mat-sort-header> Destinatario
          <rem-string-filter #tableFilter columnDef="nombreDealer" [operators]="operators" (filterChange)="filterChange($event);"></rem-string-filter>
        </th>
        <td mat-cell class="center-padding" *matCellDef="let element">
           <span>
                {{element.nombreDealer}}
           </span>
        </td>
      </ng-container>

      <!-- descAlmacen -->
      <ng-container matColumnDef="descAlmacen">
        <th mat-header-cell *matHeaderCellDef mat-sort-header> Almacen
          <rem-string-filter #tableFilter columnDef="descAlmacen" [operators]="operators" (filterChange)="filterChange($event);"></rem-string-filter>
        </th>
        <td mat-cell class="center-padding" *matCellDef="let element">
           <span>
                {{element.descAlmacen}}
           </span>
        </td>
      </ng-container>


      <!-- Shipper -->
      <ng-container matColumnDef="nroShipper">
        <th mat-header-cell *matHeaderCellDef mat-sort-header> Shipper
          <rem-string-filter #tableFilter columnDef="nroShipper" [operators]="operators" (filterChange)="filterChange($event);"></rem-string-filter>
        </th>
        <td mat-cell  class="center-padding" *matCellDef="let element">
              <span>
                {{element.nroShipper}}
              </span>
        </td>
      </ng-container>



      <!-- Fecha -->
      <ng-container matColumnDef="fecGen">
        <th mat-header-cell *matHeaderCellDef mat-sort-header> Fecha
          <rem-date-filter #tableFilter columnDef="fecGen" [operators]="dateOperators" (filterChange)="filterChange($event);"></rem-date-filter>
        </th>
        <td mat-cell  class="center-padding" *matCellDef="let element"> {{element.fecGen | customDate}} </td>
      </ng-container>



      <!-- Ship to -->
      <ng-container matColumnDef="shipTo">
        <th mat-header-cell *matHeaderCellDef mat-sort-header> Ship to
          <rem-string-filter #tableFilter columnDef="shipTo" [operators]="operators" (filterChange)="filterChange($event);"></rem-string-filter>
        </th>
        <td mat-cell class="center-padding" *matCellDef="let element">
           <span>
                {{element.shipTo}}
           </span>
        </td>
      </ng-container>


      <!-- Ship from -->
      <ng-container matColumnDef="shipFrom">
        <th mat-header-cell *matHeaderCellDef mat-sort-header> Ship from
          <rem-string-filter #tableFilter columnDef="shipFrom" [operators]="operators" (filterChange)="filterChange($event);"></rem-string-filter>
        </th>
        <td mat-cell class="center-padding" *matCellDef="let element">
           <span>
                {{element.shipFrom}}
           </span>
        </td>
      </ng-container>


      <!-- Transporte -->
      <ng-container matColumnDef="nombreTransp">
        <th mat-header-cell *matHeaderCellDef mat-sort-header> Transporte
          <rem-string-filter #tableFilter columnDef="nombreTransp" [operators]="operators" (filterChange)="filterChange($event);"></rem-string-filter>
        </th>
        <td mat-cell class="center-padding" *matCellDef="let element">
           <span>
                {{element.nombreTransp}}
           </span>
        </td>
      </ng-container>



      <!-- estadoRemito -->
      <ng-container matColumnDef="estadoRemito">
        <th mat-header-cell *matHeaderCellDef mat-sort-header> Status
          <rem-string-filter #tableFilter columnDef="estadoRemito" [operators]="operators" (filterChange)="filterChange($event);"></rem-string-filter>
        </th>
        <td mat-cell class="center-padding" *matCellDef="let element">
           <span>
                {{element.estadoRemito}}
           </span>
        </td>
      </ng-container>


      <tr mat-header-row *matHeaderRowDef="displayedColumns;sticky: true"></tr>
      <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>

    </table>

  </div>


  <mat-paginator #paginator
                 [pageSize]="10"
                 [pageSizeOptions]="[10, 15, 20, 25]"
                 [hidden]="!dataSource.data.length">
  </mat-paginator>





</div>




